import './sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { queryClient } from './lib/queryClient';
import { installInterFace } from './lib/interFace';
import { installStaleChunkReload } from './lib/staleChunkReload';
import { installDemoCopySentryTags } from './lib/auth/demoCopySentry';
import { useAuthStore } from './stores/authStore';
import './index.css';
import '@fontsource-variable/inter';
import '@fontsource-variable/fraunces';

installInterFace();
installStaleChunkReload();
installDemoCopySentryTags(useAuthStore);

const googleClientId =import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';

function Root(): JSX.Element {
  const app = (
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );

  if (!googleClientId) {
    return app;
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId} nonce="">
      {app}
    </GoogleOAuthProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
